// The survey's own page — its URL, so opening a survey lands here. Child of
// the shared survey layout (surveys.$surveyId.tsx), which already resolved
// the survey and handles its loading/not-found states, so this only needs
// the survey itself.

import { createFileRoute } from "@tanstack/react-router";
import { useSurvey } from "@/api/surveys";
import { SurveyPage } from "@/features/surveys/survey-page";

export const Route = createFileRoute("/w/$workspaceId/surveys/$surveyId/")({
    component: SurveyIndexRoute,
});

function SurveyIndexRoute() {
    const { workspaceId, surveyId } = Route.useParams();
    const surveyQuery = useSurvey(surveyId);

    // The parent layout already gated on the survey loading/existing before
    // rendering this Outlet, and shares the same query cache key — so
    // `survey` is settled by the time this mounts. Still guarded rather than
    // asserted, since TypeScript can't see across the route boundary.
    const survey = surveyQuery.data;
    if (!survey) return null;

    return <SurveyPage survey={survey} workspaceId={workspaceId} />;
}
